import React, { useState } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useHistory } from 'react-router';
import { Input, Space, Button, Checkbox, Tooltip, Form } from 'antd';
import Swal from 'sweetalert2';
import axios from 'axios';
import { decodeToken } from 'react-jwt';
import { UserOutlined, EyeTwoTone, EyeInvisibleOutlined, LockOutlined, LockFilled, UnlockFilled } from '@ant-design/icons';
import { useStateValue } from '../../../../providers/StateProvider';
import { catchRequest } from '../../../../utils';
import { registerServiceWorker } from '../../../../utils/registerServiceWorker';

const LoginForm = () => {
    const [data, setData] = useState({ usuario: '', contrasenia: '', sesion: false });
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const [, dispatch] = useStateValue();

    const handleChange = (e, type) => {
        if (type === 'sesion') { setData({ ...data, [type]: e.target.checked }); } else { setData({ ...data, [type]: e.target.value }); }
    };

    const changeScreen = (token, avisoPrivacidad) => {
        const info = decodeToken(token).result;
        let timerInterval;
        Swal.fire({
            title: `Bienvenido ${ info?.nombre }`,
            icon: 'success',
            html: 'Cargando pantalla principal',
            timer: 450,
            timerProgressBar: true,
            onBeforeOpen: () => {
                setLoading(false);
                Swal.showLoading();
                timerInterval = setInterval(() => {
                    const content = Swal.getContent();
                    if (content) {
                        const b = content.querySelector('b');
                        if (b) {
                            b.textContent = Swal.getTimerLeft();
                        }
                    }
                }, 100);
            },
            onClose: () => {
                clearInterval(timerInterval);
            },
        }).then(async () => {
            registerServiceWorker();// registramos el service worker. Tiene que pasar por varios estados para estar listo para usarse. Desde el hook useServiceWorker se obtiene el registro
            dispatch({
                type: 'ADD_USER_INFO',
                item: {
                    user: info.userLvl === 1 && info.entidad,
                    name: info.nombre,
                    mail: info.correo,
                    id: info.id,
                    lvl: info.userLvl,
                    depto: info?.id_direccion,
                    priv: info?.privilegio,
                    privilegios: info?.privilegios,
                    puesto: info?.puesto,
                    accessFtp: token?.ftp,
                    phone: info?.telefono,
                    prorrogas: info?.prorrogas,
                    contratos: info?.contratos,
                    multas: info?.multas,
                    puestoNombre: info?.puesto_nombre,
                    entidad: info?.nombre_completo,
                    estatus: info?.eliminado,
                    verificado: info?.verificado,
                    avisoPrivacidad,
                },
            });
            history.push('/');
        });
    };

    const login = () => {
        axios.post('/auth/signin', {
            usuario: data.usuario,
            contrasenia: data.contrasenia,
            mantener: data.sesion,
        })
            .then((res) => {
                if (!res.data.ok) {
                    setLoading(false);
                    Swal.fire({
                        icon: 'warning',
                        title: 'Datos incorrectos',
                        text: 'El usuario o contraseña no coincide.',
                    });
                } else {
                    dispatch({
                        type: 'ADD_TOKEN',
                        item: { token: res.data.result },
                    });
                    changeScreen(res.data.result, res.data.avisoPrivacidad);
                    if (!res.data.avisoPrivacidad) {
                        localStorage.setItem('avisoPrivacidad', res.data.avisoPrivacidad);
                    }
                }
            })
            .catch((e) => {
                setLoading(false);
                catchRequest(e, dispatch);
            });
    };

    const handleSubmit = () => {
        setLoading(true);
        login();
    };

    return (
        <Form
            layout="vertical"
            onFinish={handleSubmit}
            size={25}
            requiredMark
        >
            <Space direction="vertical" size={0}>
                <Form.Item
                    name="nombre"
                    rules={[{ required: true, message: 'Ingrese el usuario o correo electrónico' }]}
                >
                    <Input
                        size="large"
                        placeholder="Usuario"
                        onChange={(e) => handleChange(e, 'usuario')}
                        prefix={<UserOutlined />}
                        rules={[{ required: true }]}
                    />
                </Form.Item>
                <Form.Item
                    name="contrasenia"
                    rules={[{ required: true, message: 'Ingrese su contraseña' }]}
                >
                    <Input.Password
                        size="large"
                        placeholder="Ingresar contraseña"
                        prefix={<LockOutlined />}
                        onChange={(e) => handleChange(e, 'contrasenia')}
                        iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}

                    />
                </Form.Item>
                <div>
                    <Checkbox onChange={(e) => handleChange(e, 'sesion')} className="mb-3">
                        <Tooltip title="Mantiene la sesión iniciada por un largo periodo aunque se cierre el navegador.">
                            No cerrar sesión
                        </Tooltip>
                    </Checkbox>
                    <Form.Item>
                        <Button
                            block
                            type="primary"
                            icon={data.contrasenia.length > 0 ? <UnlockFilled /> : <LockFilled />}
                            loading={loading}
                            htmlType="submit"
                        >
                            Iniciar
                        </Button>
                    </Form.Item>
                </div>
            </Space>
        </Form>
    );
};
export default LoginForm;
